import { useEffect } from 'react'

const useTimer = (
  currentItem: string,
  items: string[],
  setter: (id: string) => void,
  stop: boolean
) => {
  useEffect(() => {
    const interval = setInterval(() => {
      if (!stop) {
        const currentItemIndex = items.indexOf(currentItem)
        const nextItemIndex =
          currentItemIndex + 1 === items.length ? 0 : currentItemIndex + 1
        setter(items[nextItemIndex])
      }
    }, 5000)
    return () => clearInterval(interval)
  }, [currentItem, items, setter, stop])
}

export default useTimer
